import React from 'react';
import { useAnnouncementContext } from 'Context/AnnouncementContext';
import { Disclosure } from 'Packages/FacetDesign/Components/Experimental/disclosure';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { dataAttrs } from 'Helpers/Testing';
import ThrowInDev from 'Helpers/ThrowInDev';

const metaOverrideSet = buildFacetDesignOverride().override(
  { hint: 'richtext', readonly: true },
  {
    _component: () => Richtext,
    _customProps: { unspaced: true },
  },
  overrideReadOnly,
);

export const AnnouncementBanner = () => {
  const {
    banner: {
      resource,
      canBeShown,
      initializing,
      markAsDismissed,
      isDismissible,
    },
  } = useAnnouncementContext();
  if (!canBeShown || initializing || !resource) return null;
  let stepResource;
  try {
    stepResource = resource?.attr('steps')?.resources()?.head();
  } catch (err) {
    // Breaking the dashboard would be quite horrible, so if there's an error here, let's not make too big of a fuss in prod
    return <ThrowInDev err={err} />;
  }

  return (
    <Disclosure
      title={<MetaControl resource={stepResource} attrName="title" metaOverrideSet={metaOverrideSet} />}
      content={<MetaControl resource={stepResource} attrName="content" metaOverrideSet={metaOverrideSet} />}
      onClose={isDismissible ? markAsDismissed : undefined}
      {...dataAttrs('announcement-banner')}
    />
  );
};
